import { useState } from 'react';

const AddEditActiveTrayManagementPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [
      showAddEditActiveTrayManagementPopup,
      setShowAddEditActiveTrayManagementPopup,
    ] = useState<boolean>(false);

    const addActiveTrayToggleHandler = () => {
      setShowAddEditActiveTrayManagementPopup(
        !showAddEditActiveTrayManagementPopup
      );
    };

    return (
      <Component
        showAddActiveTrayManagementPopup={showAddEditActiveTrayManagementPopup}
        addActiveTrayToggleHandler={addActiveTrayToggleHandler}
        {...props}
      />
    );
  };

export default AddEditActiveTrayManagementPopupHOC;
